
const saveIssueTitle = (state = '', action) => {
    switch (action.type) {
        case 'SAVE_ISSUE_TITLE':
            return action.issue
        default:
            return state
    }
}

export default saveIssueTitle